import { useState } from "react";
import { getUtilityConnectionUrl } from "services/utilityConnectionUrl";

const useGetUtilityConnectionUrl = (hybridToken: string) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const [url, setUrl] = useState<string | null>(null);

  const getUrl = async (prospectId: string) => {
    setLoading(true);
    try {
      const { url } = await getUtilityConnectionUrl(hybridToken, prospectId);
      setUrl(url);
    } catch (error) {
      setError(error as Error);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    url,
    getUrl,
  };
};

export { useGetUtilityConnectionUrl };
